{
  "version": 1,
  "asset_id": "0629dc89-3856-4d30-86a1-fa6073a2e161",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/0629dc89-3856-4d30-86a1-fa6073a2e161/g19.jpg",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/0629dc89-3856-4d30-86a1-fa6073a2e161/g19.jpg",
  "original_filename": "g19.jpg",
  "size": 2040629,
  "content_type": "image/jpeg",
  "created_at": "2026-07-02T22:52:58Z"
}
